// errorMessages.ts
export enum TicketCategoryErrorMessages {
    CategoryNameRequired = 'Category Name is required',
    StatusRequired = 'Status is required',
    GenericError = 'An error occurred',
}
